import React from 'react';
import C from '@ordermentum/ui-constants';
import { trackEvent } from '../Analytics/redux/actions';
import BusinessFormV2 from './Form/BusinessFormV2';
import {
  Background,
  BodyContainer,
  HeaderWrapper,
  PageContainer,
} from '../Login/LoginBase.styles';
import { Logo } from '../Login/DefaultLogin';
import history from '../../lib/history';
import { Props } from './index';

export const SupplierRegisterV2 = (props: Props) => {
  const { user, location } = props;
  const { id } = user;

  if (!id) {
    history.push('/sign-in/supplier');
  }

  return (
    <Background>
      <HeaderWrapper>
        <PageContainer type="default">
          <Logo src={`${C.IMAGE_URL}/logo-ordermentum-full.svg`} />
        </PageContainer>
      </HeaderWrapper>
      <PageContainer>
        <BodyContainer type="default">
          <div className="flex flex-col">
            <div className="mb-xxs font-heading text-h3">
              Tell us about your business
            </div>
            <p>
              Once we know a little more about you, we can get you started on a
              free trial of Ordermentum.
            </p>
            <BusinessFormV2
              userId={id as string}
              location={location}
              trackEvent={trackEvent}
            />
          </div>
        </BodyContainer>
      </PageContainer>
    </Background>
  );
};
